import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import UpgradeLicenseModal from 'components/elements/UpgradeLicenseModal'

import {
  selectActualCompanyId,
  selectActualLicenses,
  selectPartner,
  selectSelfCompanyDomain,
  selectUserEmail,
} from '../App/selectors'

import actions from './actions'
import {
  selectError,
  selectFreeTrialIsValid,
  selectIsLoading,
  selectIsSuccussful,
  selectMessage,
} from './selectors'

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)
const mapStateToProps = (state) => ({
  licenses: selectActualLicenses(state),
  partner: selectPartner(state),
  companyId: selectActualCompanyId(state),
  companyDomain: selectSelfCompanyDomain(state),
  userEmail: selectUserEmail(state),
  loader: selectIsLoading(state),
  isValid: selectFreeTrialIsValid(state),
  message: selectMessage(state),
  error: selectError(state),
  success: selectIsSuccussful(state),
})

const render = connect(mapStateToProps, mapDispatchToProps)(UpgradeLicenseModal)

export default render
